<template>
    <div class="big-expedition">
        <BaseHero :title="'Большая научная экспедиция'" :descr="heroDescr" :img="'img/hero7.jpg'"
            :imgMobile="'img/hero7-mobile.jpg'" />
        <MainSection>
            <SectionWhite>
                <BaseTextBlock class="mb-100">
                    <p class="mb-10">
                        Авария 2020 года на&nbsp;норильской ТЭЦ-3 привела к&nbsp;значительным изменениям
                        в&nbsp;экологической
                        политике &laquo;Норникеля&raquo; и&nbsp;в&nbsp;сознании работников. В&nbsp;компании решили
                        не&nbsp;просто снизить воздействие производств на&nbsp;окружающую среду до&nbsp;минимальных
                        значений,
                        а&nbsp;добиться нулевых нетто-потерь биоразнообразия и&nbsp;постепенного восстановления
                        нарушенных
                        экосистем. Но&nbsp;без достоверной научной информации понять, что для&nbsp;этого требуется,
                        невозможно.
                        Первым шагом в&nbsp;правильном направлении стала Большая Норильская экспедиция, которая прошла
                        с&nbsp;2020 по&nbsp;2022&nbsp;годы.
                    </p>
                    <p class="mb-28">
                        &laquo;Норникель&raquo; и&nbsp;Сибирское отделение Российской академии наук решили продолжить
                        сотрудничество. Так&nbsp;родилась идея Большой научной экспедиции. Она стартовала одновременно
                        с&nbsp;завершением Большой Норильской экспедиции. Компании было важно оценить воздействие всех
                        своих
                        производств не&nbsp;только на&nbsp;Таймыре, но&nbsp;и&nbsp;в&nbsp;других регионах деятельности
                        Компании:
                        на&nbsp;Кольском полуострове, в&nbsp;Забайкалье и&nbsp;в&nbsp;Ямало-Ненецком автономном округе,
                        а&nbsp;также вдоль Северного морского пути.
                    </p>

                    <a class="link" href="/expedition" target="_blank">
                        <div>Читать про Норильскую экспедицию</div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="8" viewBox="0 0 20 8" fill="none">
                            <path
                                d="M19.8536 4.35355C20.0488 4.15829 20.0488 3.84171 19.8536 3.64645L16.6716 0.464466C16.4763 0.269204 16.1597 0.269204 15.9645 0.464466C15.7692 0.659728 15.7692 0.976311 15.9645 1.17157L18.7929 4L15.9645 6.82843C15.7692 7.02369 15.7692 7.34027 15.9645 7.53553C16.1597 7.7308 16.4763 7.7308 16.6716 7.53553L19.8536 4.35355ZM0 4.5H19.5V3.5H0V4.5Z"
                                fill="black" />
                        </svg>
                    </a>
                </BaseTextBlock>
                <div class="big-expedition__tasks">
                    <div class="big-expedition__tasks-title title">
                        Задачи Большой научной экспедиции
                    </div>

                    <div class="big-expedition__tasks-wrap">
                        <div class="big-expedition__tasks-img-block">
                            <img src="img/tasks-block.png" alt="">
                            <div>Определить мероприятия <br />для сохранения биоразнообразия <br />животных
                                и&nbsp;растений</div>
                        </div>
                        <div class="big-expedition__tasks-item big-expedition__tasks-item_1">
                            <div class="big-expedition__tasks-number">
                                1
                            </div>
                            <div class="big-expedition__tasks-text">
                                Изучить, какое воздействие на&nbsp;биоразнообразие экосистем оказывает деятельность
                                предприятий
                                «Норникеля»
                            </div>
                        </div>
                        <div class="big-expedition__tasks-item big-expedition__tasks-item_2">
                            <div class="big-expedition__tasks-number">
                                2
                            </div>
                            <div class="big-expedition__tasks-text">
                                Опробовать на&nbsp;практике методы, которые позволяют отследить изменения
                                в&nbsp;состоянии
                                экосистем на&nbsp;ранних этапах, когда они&nbsp;ещё&nbsp;незаметны&nbsp;глазу
                            </div>
                        </div>
                        <div class="big-expedition__tasks-item big-expedition__tasks-item_3">
                            <div class="big-expedition__tasks-number">
                                3
                            </div>
                            <div class="big-expedition__tasks-text">
                                Определить степень негативного воздействия (уровень условных потерь биоразнообразия)
                            </div>
                        </div>
                        <div class="big-expedition__tasks-item big-expedition__tasks-item_4">
                            <div class="big-expedition__tasks-number">
                                4
                            </div>
                            <div class="big-expedition__tasks-text">
                                Изучить и&nbsp;оценить текущее состояние экосистем, разнообразие растений
                                и&nbsp;животных
                            </div>
                        </div>
                    </div>
                </div>
                <BaseTextBlock class="big-expedition__tasks-before mb-60 text-center">
                    <span>
                        Кроме того, в&nbsp;ходе экспедиции учёные разрабатывали и&nbsp;апробировали методы, которые
                        позволяют
                        провести чёткую границу между естественными причинами изменения экосистем и&nbsp;изменениями
                        из-за
                        промышленного воздействия.
                    </span>
                </BaseTextBlock>
                <BaseSidebar class="mb-100">
                    <p>
                        &laquo;Норникель&raquo; работает над сохранением 14&nbsp;морских экосистем
                        и&nbsp;15&nbsp;экосистем
                        суши. Сотрудничество с&nbsp;научными организациями&nbsp;&mdash; одно из&nbsp;обязательств,
                        взятых
                        компанией в&nbsp;рамках экологической стратегии.
                    </p>
                </BaseSidebar>
                <BaseTextBlock class="mb-40 big-expedition__start-expedition" :title="'Старт экспедиции'">
                    <span>
                        Полевой этап работ Большой научной экспедиции начался весной 2022&nbsp;года. Несколько групп
                        учёных
                        отправились в&nbsp;локации производственной активности &laquo;Норникеля&raquo;, чтобы
                        обследовать
                        территории
                        в&nbsp;радиусе примерно 15&nbsp;км вокруг промышленных площадок.
                    </span>
                </BaseTextBlock>
                <div class="big-expedition__tasks-map mb-100">
                    <img loading="lazy" src="img/tasks-block-map.svg" alt="">
                    <BaseNumberBlock :textTop="'в&nbsp;5&nbsp;регионах'"
                        :textBottom="'провели полевые работы всего&nbsp;за&nbsp;восемь месяцев'" />
                </div>

                <div class="map">
                    <ScrollSwiper class="map__wrap mb-100" />
                    <svg class="mobile-icon-scroll" xmlns="http://www.w3.org/2000/svg" width="49" height="43"
                        viewBox="0 0 49 43" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M17.2522 15.3469C17.4445 15.3469 17.6377 15.2811 17.7955 15.1466C18.147 14.8469 18.1887 14.3193 17.8885 13.9682C16.736 12.6208 16.1013 10.9023 16.1013 9.12929C16.1013 5.01713 19.4518 1.67171 23.5701 1.67171C27.6885 1.67171 31.039 5.01713 31.039 9.12929C31.039 10.9023 30.4043 12.6208 29.2518 13.9681C28.9516 14.3191 28.9932 14.8467 29.3447 15.1465C29.6964 15.4463 30.2248 15.4047 30.5249 15.0538C31.936 13.404 32.7132 11.3 32.7132 9.12929C32.7132 4.09535 28.6116 0 23.5701 0C18.5286 0 14.4271 4.09535 14.4271 9.12929C14.4271 11.3 15.2042 13.404 16.6153 15.0538C16.7809 15.2475 17.0158 15.3469 17.2522 15.3469ZM37.2992 33.2569C37.117 35.1289 36.3767 36.89 35.2146 38.2162C33.6211 40.0348 31.4197 40.9569 28.6713 40.9569C23.6455 40.9569 20.6547 36.6329 20.626 36.5906C20.6157 36.5752 20.6048 36.5602 20.5935 36.5456C18.475 33.8071 14.7644 26.9786 13.6775 24.9511C13.6716 24.9401 13.6735 24.9258 13.6762 24.9181C14.7728 24.2996 16.1283 24.6072 16.9038 25.6516L20.6622 30.7131C20.8773 31.0028 21.2541 31.1221 21.5972 31.009C21.9401 30.8959 22.1718 30.576 22.1718 30.2153V9.24948C22.1718 8.82245 22.3392 8.41513 22.6312 8.13203C22.888 7.88286 23.2153 7.75121 23.5609 7.76116C24.2858 7.78222 24.8757 8.47155 24.8757 9.2978V20.3073V22.4185C24.8757 22.8802 25.2504 23.2544 25.7128 23.2544C26.175 23.2544 26.5499 22.8802 26.5499 22.4185V20.3307C26.581 19.5318 27.1726 18.9069 27.8998 18.9069C28.6452 18.9069 29.2517 19.5749 29.2517 20.3958V23.2098C29.2517 23.6714 29.6266 24.0456 30.0888 24.0456C30.5512 24.0456 30.9259 23.6714 30.9259 23.2098C30.9259 22.3889 31.5324 21.7209 32.278 21.7209C33.0234 21.7209 33.6298 22.3889 33.6298 23.2098V25.4738C33.6298 25.578 33.6493 25.6813 33.6874 25.7783L33.7276 25.881C33.864 26.2291 34.215 26.4449 34.588 26.4084C34.9606 26.3723 35.264 26.0935 35.3308 25.7257C35.4567 25.0333 36.0139 24.5307 36.656 24.5307C37.3905 24.5307 37.99 25.1789 38.0076 25.983L37.2992 33.2569ZM36.656 22.859C38.3247 22.859 39.6823 24.2767 39.6823 26.0195C39.6823 26.0465 39.6809 26.0735 39.6783 26.1004L38.9656 33.4187C38.7498 35.6354 37.8651 37.7301 36.4745 39.3169C34.5764 41.4834 31.878 42.6286 28.6713 42.6286C22.8888 42.6286 19.5497 37.9781 19.253 37.5474C17.1139 34.7734 13.6108 28.3692 12.2015 25.7399C11.7699 24.9349 12.0546 23.9176 12.8359 23.4721C14.6816 22.4199 16.958 22.9178 18.2488 24.656L20.4975 27.6845V9.24948C20.4975 8.37334 20.8501 7.52896 21.4648 6.93283C22.0491 6.36612 22.8122 6.06663 23.6096 6.09012C25.2309 6.13726 26.5499 7.57627 26.5499 9.2978V17.5632C26.956 17.353 27.4144 17.2352 27.8998 17.2352C29.5641 17.2352 30.919 18.6459 30.9259 20.3826C31.333 20.1693 31.7923 20.0492 32.2779 20.0492C33.9408 20.0492 35.2948 21.4576 35.304 23.192C35.7134 22.9782 36.1736 22.859 36.656 22.859ZM27.3682 12.8811C26.9907 12.6146 26.9009 12.0931 27.1677 11.7161C27.694 10.9726 27.9722 10.0971 27.9722 9.18462C27.9722 6.76098 25.9974 4.7892 23.5701 4.7892C21.1428 4.7892 19.1681 6.76098 19.1681 9.18462C19.1681 10.1102 19.4533 10.9958 19.993 11.7454C20.2629 12.1202 20.1774 12.6426 19.8019 12.912C19.6541 13.0182 19.4832 13.0692 19.314 13.0693C19.0537 13.0693 18.7971 12.9484 18.6336 12.7212C17.8879 11.6855 17.4938 10.4626 17.4938 9.18462C17.4938 5.8392 20.2196 3.11749 23.5701 3.11749C26.9206 3.11749 29.6464 5.8392 29.6464 9.18462C29.6464 10.4446 29.2621 11.6536 28.535 12.6809C28.2682 13.0579 27.7457 13.1476 27.3682 12.8811Z"
                            fill="#C5C5C6" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.99145 9.48455L3.16866 8.8144H9.47678C9.93505 8.8144 10.3065 8.44165 10.3065 7.98181C10.3065 7.52197 9.93505 7.14922 9.47678 7.14922H3.16858L3.99136 6.47907C4.34716 6.18925 4.40151 5.66496 4.11267 5.30787C3.82375 4.95085 3.30126 4.8964 2.94562 5.18623L0.306926 7.33539L0.305017 7.33705C0.282531 7.35554 0.260875 7.37527 0.24038 7.39608C0.235152 7.40125 0.230755 7.40682 0.225776 7.41215C0.210841 7.42806 0.196403 7.44429 0.182795 7.46128C0.176489 7.4691 0.170846 7.47726 0.164872 7.48534C0.153338 7.50074 0.142137 7.51648 0.131765 7.53271C0.126289 7.54129 0.121144 7.55003 0.116082 7.55877C0.106208 7.57551 0.0967494 7.59266 0.088037 7.61014C0.0838053 7.61872 0.0795732 7.62729 0.0757563 7.63595C0.0672098 7.65452 0.0595764 7.6735 0.0524405 7.69274C0.0494534 7.70098 0.0462175 7.70922 0.0433963 7.71755C0.0366753 7.73786 0.0310329 7.75851 0.0258054 7.77941C0.023814 7.78732 0.0214075 7.79506 0.0196651 7.80314C0.0148525 7.82512 0.0113676 7.84751 0.00829744 7.87016C0.00730176 7.87732 0.00589116 7.8844 0.0050614 7.89172C0.00190833 7.92128 0 7.95126 0 7.98181C0 8.01228 0.00190833 8.04226 0.0050614 8.0719C0.00589116 8.07914 0.00730176 8.08622 0.00829744 8.09338C0.0113676 8.11602 0.0148525 8.13842 0.0196651 8.1604C0.0214075 8.16839 0.023814 8.17622 0.0258054 8.18421C0.0310329 8.20511 0.0366753 8.22576 0.0433963 8.24599C0.0462175 8.2544 0.0493705 8.26256 0.0524405 8.2708C0.0594934 8.29004 0.0671269 8.30894 0.0756734 8.32759C0.0795733 8.33624 0.0838052 8.3449 0.0881199 8.35348C0.0967494 8.37096 0.106125 8.38795 0.115917 8.40468C0.121061 8.41351 0.126289 8.42233 0.131848 8.43099C0.142137 8.44698 0.15309 8.46247 0.164457 8.4777C0.170514 8.48603 0.176489 8.49444 0.182961 8.5026C0.195988 8.51891 0.210011 8.5344 0.224282 8.54972C0.229842 8.55572 0.234903 8.56196 0.240629 8.56779C0.260958 8.58835 0.282282 8.60784 0.304603 8.62624L0.306843 8.62823L2.94554 10.7774C3.0993 10.9027 3.28425 10.9636 3.46796 10.9636C3.70941 10.9636 3.94871 10.8584 4.11267 10.6557C4.40151 10.2987 4.34716 9.77438 3.99145 9.48455Z"
                            fill="#C5C5C6" />
                        <path
                            d="M45.138 8.81443H38.8298C38.3716 8.81443 38 8.44168 38 7.98184C38 7.522 38.3716 7.14925 38.8298 7.14925H45.138L44.3153 6.4791C43.9595 6.18936 43.9051 5.66499 44.1939 5.30798C44.4826 4.95088 45.0054 4.89635 45.3611 5.18625L47.9998 7.33542L48.0016 7.33708C48.0242 7.35565 48.0457 7.3753 48.0662 7.39611C48.0715 7.40127 48.076 7.40694 48.0809 7.41226C48.0958 7.42817 48.1103 7.44432 48.1239 7.4613C48.1301 7.46913 48.1359 7.47737 48.1419 7.48545C48.1533 7.50094 48.1645 7.51659 48.1749 7.53274C48.1803 7.54132 48.1855 7.55006 48.1905 7.5588C48.2005 7.57562 48.2099 7.59269 48.2186 7.61017C48.2228 7.61875 48.227 7.62732 48.2309 7.63606C48.2394 7.65455 48.247 7.67353 48.2542 7.69276C48.2572 7.70101 48.2604 7.70925 48.2632 7.71766C48.2699 7.73781 48.2757 7.75846 48.2808 7.77927C48.2829 7.78735 48.2852 7.79517 48.287 7.80325C48.2918 7.82523 48.2952 7.84754 48.2982 7.87011C48.2993 7.87735 48.3008 7.88451 48.3016 7.89175C48.3047 7.92131 48.3066 7.95137 48.3066 7.98184C48.3066 8.01231 48.3047 8.04237 48.3016 8.07193C48.3008 8.07917 48.2993 8.08625 48.2983 8.09341C48.2953 8.11605 48.2918 8.13845 48.287 8.16051C48.2852 8.16851 48.2829 8.17625 48.2808 8.18424C48.2757 8.20514 48.2699 8.22587 48.2632 8.24602C48.2604 8.25443 48.2572 8.26259 48.2542 8.27083C48.2471 8.29015 48.2395 8.30905 48.231 8.32761C48.227 8.33636 48.2228 8.34493 48.2185 8.35351C48.2099 8.37099 48.2006 8.38798 48.1907 8.40479C48.1856 8.41362 48.1803 8.42236 48.1748 8.43102C48.1645 8.44701 48.1535 8.46249 48.1422 8.47781C48.1361 8.48606 48.1301 8.49455 48.1237 8.50262C48.1107 8.51894 48.0967 8.53451 48.0824 8.54975C48.0768 8.55574 48.0718 8.56207 48.066 8.5679C48.0457 8.58846 48.0244 8.60795 48.002 8.62626L47.9999 8.62826L45.3612 10.7775C45.2073 10.9027 45.0225 10.9637 44.8387 10.9637C44.5973 10.9637 44.3579 10.8584 44.1939 10.6558C43.9051 10.2988 43.9595 9.7744 44.3152 9.48458L45.138 8.81443Z"
                            fill="#C5C5C6" />
                    </svg>
                </div>

                <BaseTextBlock class="mb-100">
                    <span>
                        <p class="mb-10">
                            Необъятность сибирских и&nbsp;арктических просторов&nbsp;&mdash; не&nbsp;единственная
                            сложность,
                            с&nbsp;которой столкнулись учёные. Немало проблем доставили сложный ландшафт, суровый климат
                            и&nbsp;трудности с&nbsp;логистикой: в&nbsp;некоторые районы можно было добраться только
                            на&nbsp;вертолёте. Вот почему каждый полевой выезд становился комплексной мини-экспедицией.
                        </p>
                        <p>
                            В&nbsp;поле зрения учёных попали не&nbsp;только хорошо изученные районы (например, Таймыр),
                            но&nbsp;и&nbsp;те, где исследовательская работа прежде никогда не&nbsp;проводилась. Среди
                            последних&nbsp;&mdash; газовые месторождения на&nbsp;Гыданском полуострове Ямало-Ненецкого
                            автономного
                            округа.
                        </p>
                    </span>
                    <BaseNumberBlock class="big-expedition__number_width" :textTop="'71&nbsp;300&nbsp;км&sup2;'"
                        :textBottom="'общая площадь территории, в&nbsp;пределах которой проводился сбор научных проб'" />
                </BaseTextBlock>
                <BaseTextBlock class="mb-40" :title="'Участники экспедиции'">

                    <span>
                        Большая научная экспедиция объединила представителей 13&nbsp;научно-исследовательских
                        институтов, вузов
                        и&nbsp;заповедников.
                    </span>
                </BaseTextBlock>

                <div class="big-expedition-team mb-100">
                    <video @loadeddata="videoLoaded" autoplay loop muted playsinline>
                        <source src="video/team.mov" type="video/mp4">
                        <source src="video/team.webm" type="video/webm">
                    </video>

                    <img v-if="!isLoadingOne" loading="lazy" src="img/big-expedition-team.webp" alt="">
                </div>

                <div class="big-expedition__plants mb-100">
                    <div class="big-expedition__plants-title title">
                        Предварительные результаты
                    </div>
                    <BaseTextBlock class="text">
                        <span>
                            Во&nbsp;время полевых работ участники экспедиции изучили различные группы организмов,
                            растений,
                            а&nbsp;также почвы. Полученные данные позволили им&nbsp;понять, как промышленные объекты
                            &laquo;Норникеля&raquo; влияют на&nbsp;экосистемы. Так, удалось выделить зоны интенсивного,
                            умеренного
                            и&nbsp;незначительного воздействия. Каждая из&nbsp;них характеризуется своими условиями
                            обитания,
                            что
                            сказывается на&nbsp;видовом разнообразии.
                        </span>
                    </BaseTextBlock>
                    <BaseTextBlock class="mb-60" :title="'Почвы, растительность и&nbsp;грибы'">
                        <span>
                            <p class="mb-10">
                                Во&nbsp;время изучения почв во&nbsp;всех трёх промышленных дивизионах учёные обнаружили
                                несколько
                                природных геохимических аномалий. Так,&nbsp;в&nbsp;Забайкалье они выявили участки
                                с&nbsp;высоким
                                присутствием в&nbsp;почве соединений мышьяка, а&nbsp;в&nbsp;Норильском и&nbsp;Кольском
                                дивизионах&nbsp;&mdash; никеля, меди и&nbsp;хрома.
                            </p>
                            <p>
                                Важно отметить, что речь идёт не&nbsp;просто о&nbsp;локальных загрязнениях
                                на&nbsp;относительно
                                небольшой территории, но&nbsp;и&nbsp;о&nbsp;природных особенностях&nbsp;&mdash;
                                промышленные
                                предприятия по&nbsp;добыче и&nbsp;переработке полезных ископаемых расположены как раз
                                в&nbsp;тех
                                местах, где богатые металлами руды близко подходят к&nbsp;поверхности земной коры,
                                и&nbsp;металлы
                                из&nbsp;рудных тел легко мигрируют в&nbsp;почву. Это явление учёные называют
                                геохимической
                                аномалией.
                            </p>
                        </span>
                        <div class="position-info">
                            <img loading="lazy" src="img/plants.png" alt="">
                            <div class="position-info__descr">
                                <span>
                                    Загрязнение почвы напрямую&nbsp;не&nbsp;ограничивает
                                    распространение
                                    грибов
                                    по&nbsp;разным зонам воздействия в&nbsp;Норильском дивизионе.
                                </span>
                            </div>
                            <BaseDropdownInfo title="Что не так с почвой?" :color="'#D38235'"
                                :pulsation-color="'pantone'"
                                :text="'Из-за&nbsp;природного дефицита фосфора и&nbsp;калия почвы в&nbsp;Норильском дивизионе слабо- и&nbsp;среднеплодородны. Они пригодны для растений, которые нетребовательны к&nbsp;уровню минерального питания.'" />
                        </div>
                    </BaseTextBlock>
                    <BaseSidebar class="mb-100">
                        <p>
                            По&nbsp;мнению исследователей, высокие концентрации химических элементов на&nbsp;этих
                            участках
                            угрожают разнообразию растений и&nbsp;животных, а&nbsp;потому необходимо при помощи
                            различных
                            мероприятий привести показатели почв к&nbsp;благоприятным значениям там,
                            где&nbsp;это&nbsp;возможно.
                            К&nbsp;сожалению, в&nbsp;местах геохимических аномалий это&nbsp;невозможно.
                        </p>
                    </BaseSidebar>
                    <video v-if="!isMobile" @loadeddata="videoLoadedTwo" autoplay loop muted playsinline>
                        <source src="video/scientist-plants.mov" type="video/mp4">
                        <source src="video/scientist-plants.webm" type="video/webm">
                    </video>
                    <picture v-if="!isLoadingTwo || isMobile">
                        <img loading="lazy" src="img/scientist-plants.webp" alt="">
                    </picture>
                </div>

                <div class="big-expedition__insects">
                    <BaseTextBlock class="mb-40" title="Насекомые и пауки">
                        <span>
                            <p class="mb-10">
                                Работа предприятий &laquo;Норникеля&raquo;, по&nbsp;мнению участников Большой научной
                                экспедиции,
                                не&nbsp;оказывает серьёзного влияния на&nbsp;жизнь насекомых. Например,
                                в&nbsp;Норильском
                                дивизионе
                                большинство видов жужелиц одинаково хорошо чувствуют себя как в&nbsp;непосредственной
                                близости
                                от&nbsp;промышленных площадок, так и&nbsp;на&nbsp;значительном от&nbsp;них удалении.
                                Заметную
                                отрицательную реакцию на&nbsp;выбросы демонстрируют только четыре вида жуков.
                            </p>
                            <p>
                                Разнообразие пауков на&nbsp;территории Кольского дивизиона напрямую зависит
                                от&nbsp;количества
                                растений на&nbsp;изученных участках: чем меньше растительности, тем меньше арахнид там
                                проживает.
                                Но&nbsp;в&nbsp;скудности флоры, по&nbsp;мнению биологов, повинны не&nbsp;только
                                промышленные
                                выбросы, но&nbsp;и&nbsp;пожары, которые возникают вблизи городов и&nbsp;посёлков из-за
                                человека.
                                Кроме того, северные широты сами по&nbsp;себе не&nbsp;отличаются богатым разнообразием.
                            </p>
                        </span>

                        <div class="position-info">
                            <img loading="lazy" src="img/bug-be.webp" alt="">

                            <BaseNumberBlock :textTop="'1 402'"
                                :textBottom="'экземпляра жужелиц собрано только в Норильском регионе'" />
                            <BaseDropdownInfo :title="'Как удалось поймать так много?'" :color="'#D38235'"
                                :pulsation-color="'pantone'"
                                :text="'Для ловли беспозвоночных учёные используют различные виды почвенных ловушек, энтомологические сачки и… пластиковые тарелки жёлтого цвета, которые привлекают насекомых.'" />
                        </div>
                    </BaseTextBlock>
                    <BaseSidebar class="mb-100">
                        <p>
                            Концентрация загрязняющих веществ на&nbsp;исследовательских полигонах всех четырёх
                            дивизионов
                            &laquo;Норникеля&raquo; не&nbsp;достигает значений, способных существенно повлиять
                            на&nbsp;свойства
                            экологических сообществ жужелиц.
                        </p>
                    </BaseSidebar>

                    <div class="big-expedition__insects-bug">
                        <video v-if="!isMobile" autoplay loop muted playsinline>
                            <source src="video/bug.mov" type="video/mp4">
                            <source src="video/bug.webm" type="video/webm">
                        </video>

                    </div>
                    <div class="big-expedition__insects-spider">
                        <video v-if="!isMobile" @loadeddata="videoLoadedFour" autoplay loop muted playsinline>
                            <source src="video/spider.mov" type="video/mp4">
                            <source src="video/spider.webm" type="video/webm">
                        </video>
                        <picture v-if="!isLoadingFour || isMobile">
                            <img loading="lazy" src="img/spider-2.webp" alt="">
                        </picture>
                    </div>

                    <div class="big-expedition__insects-scientist">
                        <video v-if="!isMobile" @loadeddata="videoLoadedFive" autoplay loop muted playsinline>
                            <source src="video/scientist-insects.mov" type="video/mp4">
                            <source src="video/scientist-insects.webm" type="video/webm">
                        </video>

                        <picture v-if="!isLoadingFive || isMobile">
                            <img loading="lazy" src="img/scientist-insects.webp" alt="">
                        </picture>
                    </div>
                </div>

                <div class="big-expedition__birds">
                    <BaseTextBlock class="mb-40" title="Птицы">
                        <span>
                            <p class="mb-10">
                                На&nbsp;орнитофауну Норильского дивизиона значительно влияют изменения ландшафта
                                и&nbsp;отторжение
                                территорий под строительство новых промышленных объектов. Вмешательство
                                человека&nbsp;&mdash;
                                например, изъятие территорий под карьеры&nbsp;&mdash; вынуждает птиц покидать привычные
                                места
                                гнездований и&nbsp;искать новые.
                            </p>
                            <p class="mb-10">
                                В&nbsp;непосредственной близости от&nbsp;промышленных площадок птиц очень мало,
                                но&nbsp;на&nbsp;расстоянии уже нескольких километров ситуация значительно улучшается.
                            </p>
                            <p class="mb-10">
                                В&nbsp;холодное и&nbsp;тёплое время года видовое разнообразие птиц всех трёх дивизионов
                                заметно
                                отличается: многие птицы предпочитают зимовать в&nbsp;южных регионах.
                            </p>
                            <p class="mb-10">
                                Наблюдали за&nbsp;птицами учёные и&nbsp;во&nbsp;время плавания по&nbsp;Северному
                                морскому пути.
                                В&nbsp;основном это были морские виды (большой и&nbsp;хохлатый баклан, северная олуша,
                                большой
                                поморник, гага-гребенушка и&nbsp;другие), однако на&nbsp;глаза орнитологам попались
                                также
                                охраняемые
                                виды, такие как сапсан и&nbsp;рогатый жаворонок.
                            </p>
                            <p>
                                Видовое разнообразие птиц, встреченных летом и&nbsp;осенью над акваториями Баренцева
                                и&nbsp;Карского
                                морей, отличалось незначительно&nbsp;&mdash; 29&nbsp;и&nbsp;24&nbsp;вида соответственно.
                            </p>
                        </span>
                        <div class="position-info">
                            <video v-if="!isMobile" @loadeddata="videoLoadedSix" autoplay loop muted playsinline>
                                <source src="video/big-expedition-bird.mov" type="video/mp4">
                                <source src="video/big-expedition-bird.webm" type="video/webm">
                            </video>
                            <img v-if="!isLoadingSix || isMobile" loading="lazy" src="img/big-expedition-bird.png"
                                alt="">
                            <div class="position-info__descr">
                                <span>
                                    <p class="mb-10">
                                        В&nbsp;Кольском дивизионе наибольшее видовое богатство птиц орнитологи выявили
                                        в&nbsp;зоне
                                        значительного воздействия предприятий.
                                    </p>
                                    <p>
                                        Это явление учёные связывают с&nbsp;большим количеством природных водоёмов,
                                        расположенных
                                        в&nbsp;зоне значительного воздействия, и&nbsp;живущих там видов околоводных
                                        птиц.
                                    </p>
                                </span>
                            </div>
                            <BaseDropdownInfo :title="'Почему ещё так может происходить?'" :color="'#D38235'"
                                :pulsation-color="'pantone'"
                                :text="'Промышленные и&nbsp;хозяйственные здания, расположенные рядом жилые массивы привлекают так называемых синантропных птиц&nbsp;&mdash; виды, которые живут рядом с&nbsp;человеком и&nbsp;зависят от&nbsp;его деятельности. Это воробьи, голуби и&nbsp;вороны. При удалении от&nbsp;промышленных объектов и&nbsp;городов, структура сообщества птиц резко меняется: синантропные виды и&nbsp;чайки исчезают, а&nbsp;вместо них появляются охотничьи виды.'" />
                        </div>
                    </BaseTextBlock>
                    <BaseSidebar class="mb-100">
                        <span>
                            <p class="mb-10">
                                Наиболее значительное воздействие на&nbsp;сообщества птиц предприятия
                                &laquo;Норникеля&raquo;
                                оказывают в&nbsp;Норильском промышленном районе.
                            </p>
                            <p>
                                А&nbsp;в&nbsp;соседнем Ямало-Ненецком районе, напротив, влияние настолько незначительно,
                                что
                                учёные
                                затруднились даже выделить зоны воздействия.
                            </p>
                        </span>
                    </BaseSidebar>

                    <div class="big-expedition__birds-animation">
                        <video v-if="!isMobile" @loadeddata="videoLoadedSeven" autoplay loop muted playsinline>
                            <source src="video/eagle.mov" type="video/mp4">
                            <source src="video/eagle.webm" type="video/webm">
                        </video>
                        <picture v-if="!isLoadingSeven || isMobile">
                            <img loading="lazy" src="img/eagle.webp" alt="">
                        </picture>
                    </div>

                    <div class="big-expedition__birds-white-partridge">
                        <video v-if="!isMobile" @loadeddata="videoLoadedEight" autoplay loop muted playsinline>
                            <source src="video/white-partridge.mov" type="video/mp4">
                            <source src="video/white-partridge.webm" type="video/webm">
                        </video>

                        <picture v-if="!isLoadingEight || isMobile">
                            <img loading="lazy" src="img/white-partridge.webp" alt="">
                        </picture>
                    </div>

                    <div class="big-expedition__birds-plover">
                        <video v-if="!isMobile" @loadeddata="videoLoadedNine" autoplay loop muted playsinline>
                            <source src="video/plover.mov" type="video/mp4">
                            <source src="video/plover.webm" type="video/webm">
                        </video>
                        <picture v-if="!isLoadingNine || isMobile">
                            <img loading="lazy" src="img/plover.webp" alt="">
                        </picture>
                    </div>

                    <div class="big-expedition__birds-scientist">
                        <video v-if="!isMobile" @loadeddata="videoLoadedTen" autoplay loop muted playsinline>
                            <source src="video/bird-scientist.mov" type="video/mp4">
                            <source src="video/bird-scientist.webm" type="video/webm">
                        </video>

                        <picture v-if="!isLoadingTen || isMobile">
                            <img loading="lazy" src="img/bird-scientist.webp" alt="">
                        </picture>
                    </div>
                </div>
                <div class="big-expedition__animals">
                    <BaseTextBlock class="mb-40" title="Млекопитающие">
                        <span>
                            <p class="mb-10">
                                Как&nbsp;и&nbsp;в&nbsp;случае с&nbsp;птицами, на&nbsp;видовое разнообразие млекопитающих
                                влияют
                                не&nbsp;только изменение ландшафта и&nbsp;промышленное воздействие на&nbsp;воздух, воду
                                и&nbsp;почву, но&nbsp;и&nbsp;простое изъятие территорий.
                            </p>
                            <p>
                                Впрочем, экспедиция показала, что&nbsp;сразу за&nbsp;границами промышленной зоны
                                некоторые
                                экосистемы практически не&nbsp;изменились, а&nbsp;в&nbsp;некоторых случаях
                                даже&nbsp;улучшили
                                свои
                                показатели. Так, в&nbsp;Забайкалье обочины дорог, ведущие к&nbsp;предприятиям
                                «Норникеля»,
                                заросли
                                кустарником и&nbsp;стали убежищем и&nbsp;кормовой базой для&nbsp;косуль и&nbsp;зайцев.
                                Шум&nbsp;грузовиков животных не&nbsp;пугает, зато на&nbsp;этих территориях
                                нет&nbsp;самых
                                опасных
                                их&nbsp;врагов&nbsp;— охотников.
                            </p>
                        </span>
                        <div class="position-info">
                            <video v-if="!isMobile" @loadeddata="videoLoadedEleven" autoplay loop muted
                                playsinlithis.ne>
                                <source src="video/squirrel.mov" type="video/mp4">
                                <source src="video/squirrel.webm" type="video/webm">
                            </video>
                            <img v-if="!isLoadingEleven" loading="lazy" src="img/squirrel.png" alt="">
                            <BaseNumberBlock textTop="7 видов"
                                :textBottom="'млекопитающих обнаружили в&nbsp;Кольском дивизионе в&nbsp;зимний период'" />
                            <BaseDropdownInfo title="Какие виды обнаружили учёные?" :color="'#D38235'"
                                :pulsation-color="'pantone'"
                                :text="'Исследователям удалось встретить белку, зайца-беляка, лесную куницу, горностая, росомаху, лисицу и&nbsp;лося. Численность всех видов невелика.'" />
                        </div>
                    </BaseTextBlock>
                    <BaseSidebar class="mb-100">
                        <p>
                            Учёные пришли к&nbsp;выводу, что&nbsp;наличие убежища, воды и&nbsp;пищи для&nbsp;животных
                            гораздо
                            важнее помех от&nbsp;предприятий.
                        </p>
                    </BaseSidebar>
                    <div class="fox">
                        <video v-if="!isMobile" @loadeddata="videoLoadedTwelve" autoplay loop muted playsinline>
                            <source src="video/fox.mov" type="video/mp4">
                            <source src="video/fox.webm" type="video/webm">
                        </video>
                        <picture v-if="!isLoadingTwelve || isMobile">
                            <img loading="lazy" src="img/fox.webp" alt="">
                        </picture>
                    </div>
                    <div class="marten">
                        <video v-if="!isMobile" @loadeddata="videoLoadedThirteen" autoplay loop muted playsinline>
                            <source src="video/marten.mov" type="video/mp4">
                            <source src="video/marten.webm" type="video/webm">
                        </video>

                        <picture v-if="!isLoadingThirteen || isMobile">
                            <img loading="lazy" src="img/marten.webp" alt="">
                        </picture>
                    </div>
                    <div class="hare">
                        <video v-if="!isMobile" @loadeddata="videoLoadedFourteen" autoplay loop muted playsinline>
                            <source src="video/hare.mov" type="video/mp4">
                            <source src="video/hare.webm" type="video/webm">
                        </video>
                        <picture v-if="!isLoadingFourteen || isMobile">
                            <img loading="lazy" src="img/hare.webp" alt="">
                        </picture>
                    </div>
                    <div class="ermine">
                        <video v-if="!isMobile" @loadeddata="videoLoadedFifteen" autoplay loop muted playsinline>
                            <source src="video/ermine.mov" type="video/mp4">
                            <source src="video/ermine.webm" type="video/webm">
                        </video>
                        <picture v-if="!isLoadingFifteen || isMobile">
                            <img loading="lazy" src="img/ermine.webp" alt="">
                        </picture>
                    </div>

                    <div class="scientist">
                        <video v-if="!isMobile" @loadeddata="videoLoadedSixteen" autoplay loop muted playsinline>
                            <source src="video/animals-scientist.mov" type="video/mp4">
                            <source src="video/animals-scientist.webm" type="video/webm">
                        </video>
                        <picture v-if="!isLoadingSixteen || isMobile">
                            <img loading="lazy" src="img/animals-scientist.webp" alt="">
                        </picture>
                    </div>
                </div>
                <div class="big-expedition__water-animals">
                    <BaseTextBlock class="mb-40" title="Морские млекопитающие">
                        <span>
                            <p class="mb-10">
                                На&nbsp;жизнь морских обитателей влияют шум, издаваемый судами, а&nbsp;также возможные
                                разливы
                                нефтепродуктов. Второй фактор наиболее опасен: попадая на&nbsp;кожу, топливо оставляет
                                химические
                                ожоги, изменяет воздухо- и&nbsp;теплообмен в&nbsp;организмах морских млекопитающих.
                                Это&nbsp;может
                                стать причиной гибели животных.
                            </p>
                            <p>
                                Исследования в&nbsp;рамках Большой научной экспедиции проводилось с&nbsp;борта судна
                                «Норникеля».
                                На&nbsp;нём&nbsp;учёные отправились по&nbsp;тому&nbsp;же&nbsp;маршруту, по&nbsp;которому
                                регулярно
                                перемещаются суда компании. Все&nbsp;встречи с&nbsp;морскими млекопитающими
                                фиксировались
                                в&nbsp;судовом дневнике исследований.
                            </p>
                        </span>
                        <div class="position-info">
                            <img loading="lazy" src="img/whale.png" alt="">
                            <BaseNumberBlock textTop="5 видов"
                                :textBottom="'китообразных водятся в&nbsp;районе Северного морского пути на&nbsp;участке от&nbsp;Мурманска до&nbsp;Дудинки'" />

                            <BaseDropdownInfo title="Каких китов встретили учёные?" :color="'#D38235'"
                                :pulsation-color="'pantone'"
                                :text="'В&nbsp;этом районе водятся морская свинья, северный малый полосатик, белуга, а&nbsp;также два вида крупных китов: горбач и&nbsp;финвал.'" />
                        </div>
                    </BaseTextBlock>
                    <BaseSidebar>
                        <span>
                            <p class="mb-10">
                                За&nbsp;время работ на&nbsp;судах «Норникеля» при&nbsp;переходе по&nbsp;Северному
                                морскому пути
                                не&nbsp;происходило разлива нефтепродуктов. Не&nbsp;отмечался
                                он&nbsp;и&nbsp;во&nbsp;время
                                стоянок
                                судов в&nbsp;портах Дудинки и&nbsp;Мурманска.
                            </p>
                            <p>
                                Разливов и&nbsp;не&nbsp;могло произойти, ведь&nbsp;«Норникель» принимает превентивные
                                меры
                                для&nbsp;предотвращения потенциальных разливов нефтепродуктов и&nbsp;следует всем
                                правилам
                                обращения
                                с&nbsp;судовыми сточными водами.
                            </p>
                        </span>
                    </BaseSidebar>
                </div>
            </SectionWhite>
            <SectionOrange>
                <div class="big-expedition__result mb-60">
                    <div class="big-expedition__result-title title">
                        Выводы учёных
                    </div>
                    <BaseTextBlock class="text">
                        <span>
                            Первый этап Большой научной экспедиции завершился осенью 2022&nbsp;года. Проведённые
                            комплексные
                            исследования, как признают учёные, позволили получить совершенно новые для науки данные.
                        </span>
                    </BaseTextBlock>

                    <div class="big-expedition__result-wrap">
                        <div class="big-expedition__result-item">
                            <div class="big-expedition__result-text">Устойчивость к&nbsp;загрязнениям</div>
                            <div class="big-expedition__result-descr">
                                Биоценозы демонстрируют хорошую устойчивость к&nbsp;промышленным выбросам, если только
                                не&nbsp;находятся на&nbsp;территории работающего предприятия. Уровень&nbsp;же
                                воздействия
                                производственных объектов компании &laquo;Норникель&raquo; на&nbsp;экосистемы оказался
                                сопоставим с&nbsp;воздействием города. Более серьёзную нагрузку оказывают
                                хвостохранилища,
                                и&nbsp;это нужно будет учитывать при рекультивации земель.
                            </div>
                        </div>
                        <div class="big-expedition__result-item">
                            <div class="big-expedition__result-text">Изучение в&nbsp;динамике</div>
                            <div class="big-expedition__result-descr">
                                Относительно надёжно оценить состояние экосистем можно только с&nbsp;учётом естественной
                                внутренней динамики всех компонентов. Например, почвы и&nbsp;растительные сообщества
                                достаточно стабильны во&nbsp;времени. Животные, напротив, характеризуются выраженной
                                популяционной динамикой. Получить адекватный результат можно минимум за&nbsp;два,
                                а&nbsp;то&nbsp;и&nbsp;три года наблюдений.
                            </div>
                        </div>
                        <div class="big-expedition__result-item">
                            <div class="big-expedition__result-text">Необходимость&nbsp;продолжать исследования</div>
                            <div class="big-expedition__result-descr">
                                В&nbsp;течение 2023 года на&nbsp;территориях вокруг промышленных объектов
                                &laquo;Норникеля&raquo; проходит второй этап Большой научной экспедиции.
                                Её&nbsp;участники
                                занимаются углублёнными исследованиями и&nbsp;наблюдением за&nbsp;выявленными годом
                                ранее
                                параметрами биоразнообразия. По&nbsp;итогам работы учёные проведут генетический анализ
                                различных компонентов систем и&nbsp;составят ДНК-библиотеки. Чтобы получить достоверные
                                и&nbsp;научно обоснованные данные, исследования нужно проводить
                                от&nbsp;3&nbsp;до&nbsp;5&nbsp;лет.
                            </div>
                        </div>
                    </div>

                    <BaseAccordion class="big-expedition__result-faq" v-for="faq in faqs" :key="faq.id" :faq="faq" />
                </div>
                <BaseSidebar>
                    <p>
                        Научная обоснованность и&nbsp;достоверность данных про биоразнообразие&nbsp;&mdash; основа
                        для&nbsp;принятия решений в&nbsp;области сохранения биологического разнообразия. Именно поэтому
                        &laquo;Норникель&raquo; обращается к&nbsp;авторитетным научным организациям, чтобы
                        их&nbsp;сотрудники проводили исследования и&nbsp;мониторинг в&nbsp;этой сфере.
                    </p>
                </BaseSidebar>
            </SectionOrange>
        </MainSection>
    </div>
</template>

<script>
import BaseHero from '@/layout/BaseHero.vue'
import MainSection from '@/layout/MainSection'
import SectionWhite from '@/layout/SectionWhite.vue'
import SectionOrange from '@/layout/SectionOrange.vue'
import BaseDropdownInfo from '@/components/BaseDropdownInfo.vue'
import BaseTextBlock from '@/components/BaseTextBlock.vue'
import BaseSidebar from '@/components/BaseSidebar'
import BaseNumberBlock from "@/components/BaseNumberBlock.vue";
import BaseAccordion from '@/components/BaseAccordion.vue'
import ScrollSwiper from '@/components/BigExpeditionScrollSwiper.vue'

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
export default {
    components: {
        BaseHero,
        SectionOrange,
        SectionWhite,
        BaseNumberBlock,
        BaseTextBlock,
        MainSection,
        BaseSidebar,
        ScrollSwiper,
        BaseAccordion,
        BaseDropdownInfo,
    },
    data() {
        return {
            isLoadingOne: false,
            isLoadingTwo: false,
            isLoadingThree: false,
            isLoadingFour: false,
            isLoadingFive: false,
            isLoadingSix: false,
            isLoadingSeven: false,
            isLoadingEight: false,
            isLoadingNine: false,
            isLoadingTen: false,
            isLoadingEleven: false,
            isLoadingTwelve: false,
            isLoadingThirteen: false,
            isLoadingFourteen: false,
            isLoadingFifteen: false,
            isLoadingSixteen: false,
            isMobile: (window.innerWidth <= 768),
            heroDescr: 'Три региона страны, десятки учёных, сотни взятых на&nbsp;анализ проб, тысячи километров пути&nbsp;&mdash; в&nbsp;2022 году по&nbsp;инициативе &laquo;Норникеля&raquo; стартовал первый этап Большой научной экспедиции. Работы по&nbsp;изучению экосистем проводились одновременно в&nbsp;Красноярском крае, на&nbsp;Кольском полуострове и&nbsp;в&nbsp;Забайкалье, а&nbsp;также на&nbsp;отрезке Северного морского пути и&nbsp;вокруг территорий речных портов компании на&nbsp;Енисее. Ничего сопоставимого по&nbsp;масштабу в&nbsp;нашей стране не&nbsp;было за&nbsp;весь постсоветский период.',
            faqs: [
                {
                    "question": 'Устойчивость к&nbsp;загрязнениям?',
                    "answer": 'Биоценозы демонстрируют хорошую устойчивость к&nbsp;промышленным выбросам, если только не&nbsp;находятся на&nbsp;территории работающего предприятия. Уровень&nbsp;же воздействия производственных объектов компании &laquo;Норникель&raquo; на&nbsp;экосистемы оказался сопоставим с&nbsp;воздействием города. Более серьёзную нагрузку оказывают хвостохранилища, и&nbsp;это нужно будет учитывать при рекультивации земель.',
                    "isOpen": false
                },
                {
                    "question": 'Изучение в&nbsp;динамике',
                    "answer": 'Относительно надёжно оценить состояние экосистем можно только с&nbsp;учётом естественной внутренней динамики всех компонентов. Например, почвы и&nbsp;растительные сообщества достаточно стабильны во&nbsp;времени. Животные, напротив, характеризуются выраженной популяционной динамикой. Получить адекватный результат можно минимум за&nbsp;два, а&nbsp;то&nbsp;и&nbsp;три года наблюдений.',
                    "isOpen": false
                },
                {
                    "question": 'Необходимость&nbsp;продолжать исследования',
                    "answer": 'В&nbsp;течение 2023 года на&nbsp;территориях вокруг промышленных объектов &laquo;Норникеля&raquo; проходит второй этап Большой научной экспедиции. Её&nbsp;участники занимаются углублёнными исследованиями и&nbsp;наблюдением за&nbsp;выявленными годом ранее параметрами биоразнообразия. По&nbsp;итогам работы учёные проведут генетический анализ различных компонентов систем и&nbsp;составят ДНК-библиотеки. Чтобы получить достоверные и&nbsp;научно обоснованные данные, исследования нужно проводить от&nbsp;3&nbsp;до&nbsp;5&nbsp;лет.',
                    "isOpen": false
                }
            ]
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.sidebarAnimation()
            this.textAnimation()
            // this.parallax()
        })
    },
    methods: {
        videoLoaded() {
            this.isLoadingOne = true;
        },
        videoLoadedTwo() {
            this.isLoadingTwo = true;
        },
        videoLoadedThree() {
            this.isLoadingThree = true;
        },
        videoLoadedFour() {
            this.isLoadingFour = true;
        },
        videoLoadedFive() {
            this.isLoadingFive = true;
        },
        videoLoadedSix() {
            this.isLoadingSix = true;
        },
        videoLoadedSeven() {
            this.isLoadingSeven = true;
        },
        videoLoadedEight() {
            this.isLoadingEight = true;
        },
        videoLoadedNine() {
            this.isLoadingNine = true;
        },
        videoLoadedTen() {
            this.isLoadingTen = true;
        },
        videoLoadedEleven() {
            this.isLoadingEleven = true;
        },
        videoLoadedTwelve() {
            this.isLoadingTwelve = true;
        },
        videoLoadedThirteen() {
            this.isLoadingThirteen = true;
        },
        videoLoadedFourteen() {
            this.isLoadingFourteen = true;
        },
        videoLoadedFifteen() {
            this.isLoadingFifteen = true;
        },
        videoLoadedSixteen() {
            this.isLoadingSixteen = true;
        },
        textAnimation() {
            const collageItems = Array.from(document.querySelectorAll(".text-block__wrap"))
            collageItems.forEach((elem) => {
                gsap.fromTo(elem,
                    {
                        y: 50,
                    },
                    {
                        y: 0,
                        duration: 1,
                        scrollTrigger: {
                            start: '0% 100%',
                            end: 'bottom 75%',
                            trigger: elem,
                            scrub: true,
                            // markers: true,
                        },
                    })
            })
        },
        sidebarAnimation() {
            const sidebarItems = Array.from(document.querySelectorAll(".sidebar"))
            sidebarItems.forEach((elem) => {
                gsap.fromTo(elem,
                    {
                        y: 50,
                    },
                    {
                        y: 0,
                        duration: 1,
                        scrollTrigger: {
                            start: '0% 100%',
                            end: 'bottom 75%',
                            trigger: elem,
                            scrub: true,
                        },
                    })
            })
        },
        parallax() {
            if (window.innerWidth > 768) {
                gsap.fromTo(".big-expedition__birds-animation",
                    { y: 105 },
                    {
                        y: -10,
                        scrollTrigger: {
                            trigger: ".big-expedition__birds",
                            start: '50% 100%',
                            end: '70%',
                            scrub: true
                        },

                    });

                gsap.fromTo(".big-expedition__insects-bug",
                    { y: 40, x: -10, },
                    {
                        y: -0,
                        x: 0,
                        scrollTrigger: {
                            trigger: ".big-expedition__insects",
                            start: '60% 100%',
                            end: '100%',
                            // markers: true,
                            scrub: true
                        },

                    });

                gsap.fromTo(".big-expedition__insects-spider",
                    { y: 60, x: -50 },
                    {
                        y: 0,
                        x: 0,
                        scrollTrigger: {
                            trigger: ".big-expedition__insects",
                            start: '40% 100%',
                            end: '100%',
                            // markers: true,
                            scrub: true
                        },

                    });
            }
        }
    }
}
</script>

<style lang="scss">
.big-expedition {
    overflow: hidden;

    .link {
        display: flex;
        align-items: center;
        gap: 0.625rem;
        padding: 0.764rem 1.39rem;
        border-radius: 32px;
        background: #F7F6F2;
        font-size: 1.25rem;
        font-weight: 300;
        color: var(--Gray-1, #333);
        line-height: 130%;
        transition: .3s;
        width: max-content;

        @media (max-width: 768px) {
            padding: 3.2rem;
            font-size: 4.8rem;
            text-align: center;
            width: unset;
            border-radius: 34px
        }

        svg {
            width: 20px;
            height: 8px;

            @media (max-width: 768px) {
                display: none;
            }
        }

        @media (min-width: 769px) {
            &:hover {
                color: #fff;
                background: var(--copper, #D38235);

                svg path {
                    fill: #FFF;
                }
            }
        }
    }

    .title {
        margin: 0 auto;
        color: var(--copper, #D38235);
        text-align: center;
        font-size: 2.36111rem;
        font-weight: 600;
        line-height: 130%;
        width: 29rem;

        @media (max-width: 768px) {
            width: unset;
            font-size: 6.764rem;
        }
    }

    .hero {
        @media (max-width: 768px) {
            min-height: unset;
            height: 212rem;
        }

        &__descr {
            width: 52rem;

            @media (max-width: 768px) {
                width: unset;
            }
        }
    }

    .text-center {
        text-align: center;
    }

    &__tasks {
        margin: 0 auto;

        &-title.title {
            margin-bottom: 4.722rem;
        }

        &-wrap {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0px 19.87rem 5.55556rem 18.81rem;
            width: 55.6875rem;
            height: 35.5rem;
            background-image: url(../../public/img/circle-group.svg);
            background-size: contain;
            background-repeat: no-repeat;

            @media (max-width: 768px) {
                background: none;
                flex-direction: column;
                margin: 0 0 8.1rem 0;
                width: unset;
                height: unset;
                gap: 6rem;
            }
        }

        &-img-block {
            display: flex;
            flex-direction: column;
            margin-left: 7rem;
            text-align: center;
            justify-content: center;
            gap: 1.06rem;
            width: 25rem;

            @media (max-width: 768px) {
                width: unset;
                margin-left: 0;
                gap: 4.6rem;
            }

            img {
                width: 100%;
            }

            div {
                text-align: center;
                font-size: 1.52778rem;
                font-weight: 600;
                line-height: 130%;

                @media (max-width: 768px) {
                    padding: 0 9.5rem;
                    font-size: 4.53334rem;
                    text-align: start;
                }
            }
        }

        &-map {
            margin: 0 auto;
            width: 34.5rem;
            height: 18rem;
            position: relative;

            @media (max-width: 768px) {
                width: 100%;
                height: auto;
            }

            img {
                height: 100%;

                @media (max-width: 768px) {
                    height: 81.067rem;
                    object-fit: cover;
                }
            }

            .number-block {
                background-color: #fff;
                left: -15rem;
                border-right: 1px solid #333333;
                border-left: none;
                width: 20rem;
                left: -14rem;
                bottom: 2rem;

                @media (max-width: 768px) {
                    position: static;
                    margin-left: 9.5rem;
                    width: 88%;
                    border-right: none;
                    border-left: 1px solid #333333;
                }

                &__top {
                    color: #D38235;
                }
            }
        }

        &-item {
            position: absolute;
            display: flex;
            flex-direction: column;
            gap: 0.88rem;
            width: 17rem;

            @media (max-width: 768px) {
                position: static;
                width: unset;
                flex-direction: row;
                padding: 0 9.5rem;
                gap: 3.38rem;
            }

            &_1 {
                top: 2.5rem;
                left: -3rem;
            }

            &_2 {
                top: 2.5rem;
                right: -15rem;
            }

            &_3 {
                bottom: -1.5rem;
                left: -3rem;
            }

            &_4 {
                bottom: -1.5rem;
                right: -17rem;
            }
        }

        &-number {
            position: relative;
            width: 2.2223rem;
            height: 2.2223rem;
            padding: 0.45rem 0.75rem;
            border-radius: 100%;
            font-family: 'MuseoSansCyrl';
            background-color: #D38235;
            color: #fff;
            font-size: 1.25rem;
            font-weight: 500;
            line-height: 130%;

            &::after {
                content: '';
                position: absolute;
                top: -0.1rem;
                left: -0.1rem;
                right: -0.1rem;
                bottom: -0.1rem;
                background-image: url(../../public/img/svg/circle-bg.svg);
                background-repeat: no-repeat;
                background-position: center;
                background-size: 100%;

                @media (max-width: 768px) {
                    top: -0.5rem;
                    left: -0.5rem;
                    right: -0.5rem;
                    bottom: -0.5rem;
                }
            }

            @media (max-width: 768px) {
                width: 9.7937rem;
                height: 9.7937rem;
                font-size: 4.8rem;
                padding: 2rem 3.7rem;
            }
        }

        &-text {
            font-size: 1.25rem;
            font-weight: 300;
            line-height: 130%;

            @media (max-width: 768px) {
                font-size: 4.53334rem;
            }
        }

        &-before {
            @media (max-width: 768px) {
                &.text-center {
                    text-align: start;
                }

                &.mb-60 {
                    margin-bottom: 11rem;
                }
            }
        }
    }

    &__start-expedition.mb-40 {
        @media (max-width: 768px) {
            margin-bottom: 0;
        }
    }

    .map__wrap.mb-100 {
        @media (max-width: 768px) {
            margin-bottom: 16rem;
        }
    }

    &-team {
        position: relative;
        width: 76.88rem;
        height: 26.32rem;
        margin: 0 auto;
        display: block;

        @media (max-width: 768px) {
            width: 100%;
            height: 28rem;
        }

        img {
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            width: 100%;
        }

        video {
            position: relative;
            width: 99.3%;
            left: 0.1rem;
            top: 3.6rem;
        }
    }

    &__plants {
        position: relative;
        padding-bottom: 11rem;
        background-image: url(../../public/img/big-expedition-plants.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom;

        @supports (background-image: url(../../public/img/big-expedition-plants.webp)) {
            background-image: url(../../public/img/big-expedition-plants.webp);
        }

        @media (max-width: 768px) {
            padding-bottom: 45rem;
            background-image: url(../../public/img/big-expedition-plants-mobile.png);

            @supports (background-image: url(../../public/img/big-expedition-plants-mobile.webp)) {
                background-image: url(../../public/img/big-expedition-plants-mobile.webp);
            }
        }

        picture {
            position: absolute;
            width: 25%;
            bottom: -1rem;
            left: 3rem;

            @media (max-width: 768px) {
                transform: scaleX(-1);
                width: 60%;
                bottom: -3rem;
                left: 40rem;
            }
        }

        video {
            position: absolute;
            width: 33%;
            bottom: -2rem;
            left: -1rem;

            @media (max-width: 768px) {
                transform: scaleX(-1);
                width: 86%;
                bottom: -12rem;
                left: 29rem;
            }
        }

        &-title.title {
            margin-bottom: 2.5rem;

            @media (max-width: 768px) {
                padding: 0 9.5rem;
                margin-bottom: 6.4rem;
            }
        }

        .text-block__wrap.text {
            margin-bottom: 5rem;
            text-align: center;
            width: 37rem;

            @media (max-width: 768px) {
                width: unset;
                margin-bottom: 16rem;
            }
        }

        .position-info {
            top: 5rem;
            right: -25rem;
            width: 18.7rem;

            @media (max-width: 768px) {
                width: unset;
                right: 0;
                top: 12.8rem;
            }

            img {
                width: 7.25rem;
                height: 6rem;
                margin-bottom: 0.75rem;

                @media (max-width: 768px) {
                    position: absolute;
                    margin-bottom: 0;
                    width: 22.94rem;
                    height: 19rem;
                    top: -13rem;
                    right: 8rem;
                }
            }

            &__descr {
                font-size: 1.042rem;
                margin-bottom: 0.75rem;
                line-height: 130%;

                @media (max-width: 768px) {
                    font-size: 4.53334rem;
                    padding-left: 5.3334rem;
                    margin-bottom: 5.3334rem;
                    width: 85%;
                    border-left: 1px solid #333;
                }
            }

            .dropdown-info__title {
                @media (max-width: 768px) {
                    max-width: unset;
                }
            }
        }

        .sidebar {
            width: 51rem;
        }
    }

    &__insects {
        position: relative;
        padding-bottom: 24rem;
        background-image: url(../../public/img/big-expedition-insects.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom;

        @supports (background-image: url(../../public/img/big-expedition-insects.webp)) {
            background-image: url(../../public/img/big-expedition-insects.webp);
        }

        @media (max-width: 768px) {
            margin-bottom: 14rem;
            padding-bottom: 35rem;
            background-image: url(../../public/img/big-expedition-insects-mobile.png);

            @supports (background-image: url(../../public/img/big-expedition-insects-mobile.webp)) {
                background-image: url(../../public/img/big-expedition-insects-mobile.webp);
            }
        }

        .position-info {
            top: 5rem;
            left: -22rem;
            width: 18.7rem;

            img {
                width: 6.125rem;
                height: 4.125rem;
                margin-bottom: 0.75rem;

                @media (max-width: 768px) {
                    width: 21.7rem;
                    height: 14.5rem;
                    transform: rotate(-145deg);
                    top: 0;
                    right: 6rem;
                    position: absolute;
                    margin-bottom: 0;
                }
            }

            .number-block {
                position: static;
                border-right: 1px solid #333333;
                border-left: none;
                padding-left: 0;
                margin-bottom: 1rem;
                width: 15.5rem;

                @media (max-width: 768px) {
                    width: unset;
                    border-right: none;
                    border-left: 1px solid #333333;
                    padding-left: 5.3334rem;
                    margin-bottom: 5rem;
                }
            }

            .dropdown-info__text {
                padding: 4.31rem 0.62rem 0.88rem 3.13rem;

                @media (max-width: 768px) {
                    left: -4.3rem;
                    top: -4.3rem;
                    width: 91.734rem;
                    font-size: 3.73334rem;
                    padding: 14.9334rem 6.1333rem 6.6666rem 13.8666rem;
                }
            }

            .dropdown-info__title {
                max-width: 12rem;

                @media (max-width: 768px) {
                    max-width: unset;
                }
            }

            @media (max-width: 768px) {
                width: unset;
                left: 0;
                top: 2rem;
            }
        }

        .sidebar {
            width: 46rem;
        }

        &-bug {
            position: absolute;
            top: 53.9rem;
            left: 5.9rem;
            width: 9rem;
            transform: rotateZ(81deg);
            height: 5.903rem;

            video {
                width: 100%;
            }

            @media (max-width: 768px) {
                display: none;
            }
        }

        &-spider {
            position: absolute;
            top: 61rem;
            left: 36rem;
            width: 10.78rem;

            video {
                position: absolute;
                top: 2.1rem;
                left: 0rem;
                width: 100%;
                transform: rotateZ(-16deg);
            }

            @media (max-width: 768px) {
                display: none;
            }
        }

        &-scientist {
            position: absolute;
            bottom: 40rem;
            right: -2.5rem;
            width: 30%;
            display: flex;

            picture {
                position: absolute;
                top: 0rem;
                left: 0rem;
                width: 82%;
            }

            @media (max-width: 768px) {
                transform: scaleX(-1);
                bottom: 53rem;
                right: 49.5rem;
                width: 57%;
            }

            video {
                position: absolute;
                top: -1.1rem;
                left: -2.5rem;
                width: 100%;
            }
        }
    }

    &__birds {
        position: relative;
        margin-bottom: 3.4722rem;
        padding-bottom: 29rem;
        background-image: url(../../public/img/big-expedition-birds.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom;

        @supports (background-image: url(../../public/img/big-expedition-birds.webp)) {
            background-image: url(../../public/img/big-expedition-birds.webp);
        }

        @media (max-width: 768px) {
            padding-bottom: 58rem;
            margin-bottom: 14rem;
            background-image: url(../../public/img/big-expedition-birds-mobile.png);

            @supports (background-image: url(../../public/img/big-expedition-birds-mobile.webp)) {
                background-image: url(../../public/img/big-expedition-birds-mobile.webp);
            }
        }

        .position-info {
            position: relative;
            top: 8rem;
            right: -25rem;
            width: 18.7rem;

            @media (max-width: 768px) {
                width: unset;
                right: 0;
                top: 20rem;
            }

            img,
            video {
                width: 12.25rem;
                height: 12.1875rem;
                position: absolute;
                top: -9.5rem;
                left: -3rem;

                @media (max-width: 768px) {
                    position: absolute;
                    margin-bottom: 0;
                    width: 46.12rem;
                    height: 45rem;
                    top: -29rem;
                    right: -9rem;
                    left: unset;
                    transform: scaleX(-1);
                }
            }

            &__descr {
                font-size: 1.042rem;
                margin-bottom: 0.75rem;
                line-height: 130%;

                @media (max-width: 768px) {
                    font-size: 4.53334rem;
                    padding-left: 5.3334rem;
                    margin-bottom: 5.3334rem;
                    width: 91%;
                    border-left: 1px solid #333;
                }
            }

            .dropdown-info__text {
                width: 21rem;
                padding: 4.31rem 0.62rem 0.88rem 3.13rem;

                @media (max-width: 768px) {
                    width: unset;
                    left: -4.3rem;
                    top: -4.3rem;
                    width: 91.734rem;
                    font-size: 3.73334rem;
                    padding: 14.9334rem 6.1333rem 6.6666rem 13.8666rem;
                }
            }

            .dropdown-info__title {
                @media (max-width: 768px) {
                    max-width: unset;
                }
            }
        }

        .text-block__wrap.mb-40 {
            @media (max-width: 768px) {
                margin-bottom: 30.6667rem;
            }
        }

        .sidebar {
            width: 51rem;
        }

        &-animation {
            position: absolute;
            top: 43rem;
            left: 51rem;
            width: 37.667rem;
            transform: scaleX(-1) rotateZ(15deg);

            display: flex;

            picture {
                width: 76%;
                transform: scaleX(-1) rotateZ(15deg);

            }

            video {
                position: absolute;
                top: -2rem;
                left: -5rem;
                width: 100%;
            }

            @media (max-width: 768px) {
                top: unset;
                left: unset;
                bottom: 30rem;
                right: -2rem;
                width: 53%;
            }
        }

        &-white-partridge {
            position: absolute;
            top: 60rem;
            left: 17rem;
            width: 26%;
            transform: scaleX(-1);
            display: flex;

            picture {
                width: 65%;
                transform: scaleX(-1);

            }

            video {
                position: absolute;
                width: 100%;
                top: -3rem;
                left: -4.6rem;
            }

            @media (max-width: 768px) {
                top: unset;
                bottom: -1rem;
                left: 19rem;
                width: 38%;
            }
        }

        &-plover {
            position: absolute;
            top: 69rem;
            left: 36.9rem;
            width: 24%;
            transform: scaleX(-1);

            display: flex;

            picture {
                width: 40%;

            }

            video {
                position: absolute;
                top: -6.4rem;
                left: -7rem;
                width: 100%;
            }

            @media (max-width: 768px) {
                top: unset;
                bottom: -5rem;
                left: 48rem;
                width: 38%;
            }
        }

        &-scientist {
            position: absolute;
            top: 29rem;
            left: 1rem;
            width: 22.5%;
            display: flex;

            picture {
                width: 121%;
                flex-shrink: 0;
            }

            video {
                position: absolute;
                top: 2.7rem;
                left: 2.4rem;
                width: 100%;
            }

            @media (max-width: 768px) {
                top: unset;
                bottom: 10rem;
                left: 0rem;
                width: 31%;
            }
        }
    }

    &__animals {
        position: relative;
        padding-bottom: 28rem;
        background-image: url(../../public/img/big-expedition-animals.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom;

        @supports (background-image: url(../../public/img/big-expedition-animals.webp)) {
            background-image: url(../../public/img/big-expedition-animals.webp);
        }

        @media (max-width: 768px) {
            padding-bottom: 58rem;
            margin-bottom: 14rem;
            background-image: url(../../public/img/big-expedition-animals-mobile.png);

            @supports (background-image: url(../../public/img/big-expedition-animals-mobile.webp)) {
                background-image: url(../../public/img/big-expedition-animals-mobile.webp);
            }
        }

        .position-info {
            position: relative;
            top: 8rem;
            left: -22rem;
            width: 18.7rem;

            @media (max-width: 768px) {
                width: unset;
                left: 0;
                top: 2rem;
            }

            img,
            video {
                width: 10.375rem;
                position: absolute;
                top: -9rem;

                @media (max-width: 768px) {
                    width: 32.24rem;
                    right: -2rem;
                    top: -12rem;
                    transform: scaleX(-1);
                }
            }

            video {
                width: 70%;
                left: -1rem;

                @media (max-width: 768px) {
                    left: unset;
                    width: 56%;
                    top: -17rem;
                    right: -9rem;
                }
            }

            .number-block {
                position: static;
                border-right: 1px solid #333333;
                border-left: none;
                padding-left: 0;
                margin-bottom: 1rem;
                width: 15.5rem;

                @media (max-width: 768px) {
                    width: unset;
                    border-right: none;
                    border-left: 1px solid #333333;
                    padding-left: 5.3334rem;
                    margin-bottom: 5rem;
                }
            }

            .dropdown-info__text {
                padding: 4.31rem 0.62rem 0.88rem 3.13rem;

                @media (max-width: 768px) {
                    left: -4.3rem;
                    top: -4.3rem;
                    width: 91.734rem;
                    font-size: 3.73334rem;
                    padding: 14.9334rem 6.1333rem 6.6666rem 13.8666rem;
                }
            }

            .dropdown-info__title {
                @media (max-width: 768px) {
                    max-width: unset;
                }
            }
        }

        .text-block__wrap.mb-40 {
            @media (max-width: 768px) {
                margin-bottom: 12rem;
            }
        }

        .sidebar {
            width: 36rem;
        }

        .fox {
            width: 24%;
            bottom: 37rem;
            left: 1rem;
            position: absolute;
            display: flex;

            picture {
                position: absolute;
                top: 0rem;
                left: 0rem;
                width: 100%;
            }

            video {
                position: absolute;
                top: -3rem;
                left: 0rem;
                width: 100%;
            }

            @media (max-width: 768px) {
                width: 33%;
                bottom: 38rem;
                left: 2rem;
            }
        }

        .marten {
            width: 17%;
            bottom: 30rem;
            left: 19rem;
            position: absolute;
            display: flex;

            picture {
                position: absolute;
                top: 0rem;
                left: 0rem;
                width: 100%;
            }

            video {
                position: absolute;
                top: 2rem;
                left: -1.3rem;
                width: 113%;
            }

            @media (max-width: 768px) {
                display: none;
            }
        }

        .hare {
            width: 18%;
            right: 20rem;
            bottom: 29rem;
            position: absolute;
            display: flex;

            picture {
                position: absolute;
                top: 0rem;
                left: 0rem;
                width: 54%;
            }

            video {
                position: absolute;
                top: -3.6rem;
                left: -4rem;
                width: 100%;
            }

            @media (max-width: 768px) {
                width: 26%;
                right: 36rem;
                bottom: 32rem;
            }
        }

        .ermine {
            width: 18%;
            bottom: 21rem;
            right: 1rem;
            position: absolute;

            picture {
                position: absolute;
                top: 0rem;
                left: 0rem;
                width: 86%;
            }

            video {
                position: absolute;
                top: -3rem;
                left: -0.5rem;
                width: 100%;
            }

            @media (max-width: 768px) {
                width: 27%;
                bottom: 17rem;
                right: -2rem;
            }
        }

        .scientist {
            width: 26%;
            bottom: 53rem;
            right: 8.3rem;
            position: absolute;
            display: flex;

            picture {
                position: absolute;
                top: 0rem;
                left: 0rem;
                width: 86%;
            }

            video {
                position: absolute;
                width: 71.7%;
                top: 1.8rem;
                left: 0.9rem;
            }

            @media (max-width: 768px) {
                width: 47%;
                bottom: 78rem;
                right: 12.3rem;
            }
        }
    }

    &__water-animals {
        padding-bottom: 23.44rem;
        background-image: url(../../public/img/big-expedition-water-animals.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom;

        @supports (background-image: url(../../public/img/big-expedition-water-animals.webp)) {
            background-image: url(../../public/img/big-expedition-water-animals.webp);
        }

        @media (max-width: 768px) {
            padding-bottom: 58rem;
            margin-bottom: 14rem;
            background-image: url(../../public/img/big-expedition-water-animals-mobile.png);

            @supports (background-image: url(../../public/img/big-expedition-water-animals-mobile.webp)) {
                background-image: url(../../public/img/big-expedition-water-animals-mobile.webp);
            }
        }

        .position-info {
            position: relative;
            top: 7rem;
            right: -25rem;
            width: 18.7rem;

            @media (max-width: 768px) {
                width: unset;
                left: 0;
            }

            img {
                width: 16.875rem;
                height: 8.9375rem;
                position: absolute;
                top: -6.5rem;
                left: -0.5rem;

                @media (max-width: 768px) {
                    width: 46.36rem;
                    height: 24.8rem;
                    top: -6rem;
                    left: unset;
                    right: -4rem;
                    transform: rotate(16.652deg);
                }
            }

            .number-block {
                position: static;
                margin-bottom: 1rem;
                width: 19rem;

                @media (max-width: 768px) {
                    width: unset;
                    margin-bottom: 4.8rem;
                }
            }

            .dropdown-info__text {
                width: 19rem;
                padding: 4.31rem 0.62rem 0.88rem 3.13rem;

                @media (max-width: 768px) {
                    left: -4.3rem;
                    top: -4.3rem;
                    width: 91.734rem;
                    font-size: 3.73334rem;
                    padding: 14.9334rem 6.1333rem 6.6666rem 13.8666rem;
                }
            }

            .dropdown-info__title {
                @media (max-width: 768px) {
                    max-width: unset;
                }
            }
        }
    }

    &__result {

        .title {
            margin-bottom: 1.94445rem;

            @media (max-width: 768px) {
                margin-bottom: 6.4rem;
            }
        }

        .text {
            text-align: center;
            margin-bottom: 5.55556rem;

            @media (max-width: 768px) {
                text-align: left;
                margin-bottom: 11rem;
            }
        }

        &-wrap {
            justify-content: center;
            display: flex;
            gap: 3.95834rem;

            @media (max-width: 768px) {
                display: none;
            }
        }

        &-item {
            width: 24.306rem;

            &:last-child {
                width: 24.4445rem;
            }
        }

        &-text {
            font-size: 1.52778rem;
            margin-bottom: 1.94445rem;
            font-weight: 600;
            line-height: 130%;
            width: 15rem;
        }

        &-descr {
            font-size: 1.25rem;
            font-weight: 300;
            line-height: 130%;
        }

        &-faq {
            display: none;
            border-top: 0.5px solid var(--grey, #626261);

            @media (max-width: 768px) {
                display: block;
            }
        }

        &.mb-60 {
            @media (max-width: 768px) {
                margin-bottom: 10.667rem;
            }
        }
    }

    .position-info {
        position: absolute;
        display: flex;
        flex-direction: column;

        @media (max-width: 768px) {
            position: relative;
        }
    }

    .text-block__wrap {
        width: 36rem;
        z-index: 2;

        @media (max-width: 768px) {
            width: unset;
        }
    }

    .dropdown-info__text {
        background-color: #F7F6F2;

        @media (max-width: 768px) {
            left: -4.3rem;
            top: -4.3rem;
            width: 91.734rem;
            font-size: 3.73334rem;
            padding: 14.9334rem 6.1333rem 6.6666rem 13.8666rem;
        }
    }

    &__number_width {
        width: 20rem;

        @media (max-width: 768px) {
            width: unset;
        }
    }

    .sidebar {
        width: 52rem;

        @media (max-width: 768px) {
            width: unset;
        }
    }

    .section-orange,
    main {
        padding-bottom: 0;
        margin-bottom: 0;
    }
}
</style>